import { Auth0Provider } from '@auth0/auth0-react';
import Router from 'next/router';
import PropTypes from 'prop-types';
import { AuthODomain, AuthOClientId, AuthOAudience } from '../../../constants';
import Auth0ProvidedElement from '../Auth0ProvidedElement';

let redirectUri = '';
if (typeof window === 'object') {
  redirectUri = window.location.origin;
}

const onRedirectCallback = (appState) => {
  Router.replace(appState?.returnTo || '/');
};

const Auth0ProviderWrapper = ({ children }) => (
  <Auth0Provider
    domain={AuthODomain}
    clientId={AuthOClientId}
    redirectUri={redirectUri}
    audience={AuthOAudience}
    scope="read:current_user"
    onRedirectCallback={onRedirectCallback}
  >
    <Auth0ProvidedElement>{children}</Auth0ProvidedElement>
  </Auth0Provider>
);
Auth0ProviderWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Auth0ProviderWrapper;
